import { Box, Divider, Paper, Typography } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { FileList } from "../../../../../components/molecules/FileList";
import { fetchTermsException } from "../../../../../services/termsExceptions";
import { fetchVendor } from "../../../../../services/vendors";
import { i18nextParseToDate } from "../../../../../utils/i18nextParseTo";

const RouteComponent: React.FC = () => {
  const termsException = Route.useLoaderData();

  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "24px",
        width: "100%",
      }}
    >
      <Typography gutterBottom variant="h5">
        {t("termsExceptions.show.title")}
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "row", gap: "32px" }}>
        <Box>
          <Typography
            sx={{
              color: "text.secondary",
            }}
            variant="subtitle2"
          >
            {t("termsExceptions.show.createdAt")}
          </Typography>
          <Typography>
            {t("intlDateTime", i18nextParseToDate(termsException.created_at))}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              color: "text.secondary",
            }}
            variant="subtitle2"
          >
            {t("termsExceptions.show.updatedAt")}
          </Typography>
          <Typography>
            {t("intlDateTime", i18nextParseToDate(termsException.updated_at))}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Box>
          <Typography
            sx={{
              color: "text.secondary",
            }}
            variant="subtitle2"
          >
            {t("termsExceptions.show.reason")}
          </Typography>
          <Typography>{termsException.reason}</Typography>
        </Box>
      </Box>
      {!!termsException.file_attachments && (
        <>
          <Divider />
          <Box>
            <Typography variant="h6">{t("fileUpload.title")}</Typography>
            <FileList attachments={termsException.file_attachments} />
          </Box>
        </>
      )}
    </Paper>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/vendors/$vendorId/terms_exceptions",
)({
  component: RouteComponent,
  loader: async ({ params: { vendorId } }) => {
    const vendor = await fetchVendor(parseInt(vendorId, 10));

    if (!vendor?.terms_exception?.id) {
      throw redirect({
        params: { vendorId: String(vendor?.id) },
        replace: true,
        to: "/vsupplierregistration/vendors/$vendorId/terms",
      });
    }

    return fetchTermsException(vendor.terms_exception.id);
  },
});
